<template>
  <div class="step step_11"  :class="{'form__step_hidden': step != number}" :aria-labelledby="`step${number}-title`">
    <h3 class="form__title">Данные о здоровье</h3>
    <ShortFields class="step11shortfields">
      <div class="step11flex">
        <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M13 51V36.0704C13 35.4017 12.6658 34.7772 12.1094 34.4063L11.0202 33.6801C10.3942 33.2628 10.0554 32.5295 10.1433 31.7823L11.5844 19.5326C11.8214 17.5182 13.5287 16 15.557 16H18H20.443C22.4713 16 24.1786 17.5182 24.4156 19.5326L25.8567 31.7823C25.9446 32.5295 25.6058 33.2628 24.9798 33.6801L23.8906 34.4063C23.3342 34.7772 23 35.4017 23 36.0704V51" stroke="#250708" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/> <path d="M22 8C22 10.2091 21 13 18 13C15 13 14 10.2091 14 8C14 5.79086 15.7909 4 18 4C20.2091 4 22 5.79086 22 8Z" stroke="#250708" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/> <path d="M44 3H38V9M44 51H38V39M38 27H44M38 27V15M38 27V39M38 15H44M38 15V9M38 39H44M38 9H41M38 21H41M38 33H41M38 45H41" stroke="#E9041E" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/> </svg>
        <NumberInput v-model="stepsdata[number][names[0]]" :name="names[0]" :increased="!stepsdata[number][names[0]]" text="Рост*"/>
      </div>
      <div class="step11flex">
        <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M13 51V36.0704C13 35.4017 12.6658 34.7772 12.1094 34.4063L11.0202 33.6801C10.3942 33.2628 10.0554 32.5295 10.1433 31.7823L11.5844 19.5326C11.8214 17.5182 13.5287 16 15.557 16H18H20.443C22.4713 16 24.1786 17.5182 24.4156 19.5326L25.8567 31.7823C25.9446 32.5295 25.6058 33.2628 24.9798 33.6801L23.8906 34.4063C23.3342 34.7772 23 35.4017 23 36.0704V51" stroke="#250708" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/> <circle cx="40" cy="23" r="7" stroke="#E9041E" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/> <path d="M22 8C22 10.2091 21 13 18 13C15 13 14 10.2091 14 8C14 5.79086 15.7909 4 18 4C20.2091 4 22 5.79086 22 8Z" stroke="#250708" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/> <path d="M40 30V51" stroke="#E9041E" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/> <path d="M40 23L43 20" stroke="#250708" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/> <path d="M28 51L44 51" stroke="#250708" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/> </svg>
        <NumberInput v-model="stepsdata[number][names[1]]" :name="names[1]" :increased="!stepsdata[number][names[1]]" text="Вес*"/>
      </div>
    </ShortFields>
    <div class="form__btns">
      <Btn class="btn_gray" @click.native.prevent="$store.commit('prevStep')">Назад</Btn>
      <Btn @click.native.prevent="$store.commit('nextStep')" :disabled="!filled() || step != number">Далее</Btn>
    </div>
  </div>
</template>

<script>
import Btn from './ui/Btn.vue'
import { mapState } from 'vuex'
import ShortFields from './ShortFields.vue'
import NumberInput from './NumberInput.vue'

export default {
  data: (instance)=>({
    names: [`healthheight${instance.postfix}`,`healthweight${instance.postfix}`],
  }),
  components: { Btn,  ShortFields, NumberInput },
  props: {
    number: {type: Number, default: 11},
    postfix: {type: String, default: ''}
  },
  methods: {
    filled(){
      for (let name of this.names)
        if (!this.stepsdata[this.number][name])
          return false
      return  true
    }
  },
  computed: {
    ...mapState(['stepsdata','step'])
  },
}
</script>

<style lang="sass" scoped>
.step11flex
  display: flex
  svg
    display: block
    flex-shrink: 0
    width: 54px
    margin-right: 8px
  @include for-mob
    .formlabel
      padding-top: 0 !important
    &:not(:first-child)
      padding-top: var(--basespace)
.step.step_11 .step11shortfields.form__shortfields
  >*
    width: calc(50% - 15px)
</style>